
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';


@Component({
    selector: 'app-check-send-confirmation',
    imports: [
    FormsModule
],
    templateUrl: './check-send-confirmation.component.html',
    styleUrls: ['./check-send-confirmation.component.scss']
})
export class CheckSendConfirmationComponent {
  @Input() public isChecked: boolean;
  @Input() public addressString: string | undefined;
  @Output() public onChecked: EventEmitter<boolean>;

  public constructor() {
    this.isChecked = false;
    this.addressString = '';
    this.onChecked = new EventEmitter<boolean>();
  }

  public checkValue(e: Event): void {
    if (!e.target) {
      return;
    }
    let target = e.target as HTMLInputElement;
    let checked = target.checked;

    this.isChecked = checked;
    this.onChecked.emit(checked);
  }
}
